import React, { Component, createRef } from "react";
import FormRow from "../FormRow";
import TextField from "../TextField";
import ButtonRow from "../ButtonRow";
import Button from "../Button";
import "./style.scss";
import withForm, { PropsType } from "../../hoc/withForm";
import axios from "axios";
import qs from "qs";

type StateType = {
    errorMessage: string;
    hasError: boolean;
    isSend: boolean;
    formValues: object;
};

class Form extends Component<PropsType, StateType> {
    constructor(props: PropsType) {
        super(props);
        this.submit = this.submit.bind(this);
        this.setValue = this.setValue.bind(this);
        this.state = {
            formValues: this.initForm(),
            hasError: false,
            isSend: false,
            error: "",
        };
    }

    private initForm() {
        let formData = {};

        formData["form_id"] = this.props.form.id;
        formData["action"] = this.props.form.url;
        formData[this.props.form.csrfName] = this.props.form.csrfToken;

        this.props.form.fields.map(field => {
            formData[field.name] = "";
        });

        return formData;
    }

    private setValue(value: string, field: string) {
        let newFormValues = { ...this.state.formValues };

        newFormValues[field] = value;

        this.setState({
            ...this.state,
            formValues: newFormValues,
        });
    }

    private submit() {
        axios({
            url: `/${this.props.form.url}`,
            data: qs.stringify(this.state.formValues),
            responseType: "json",
            method: "POST",
            headers: { "content-type": "application/x-www-form-urlencoded" },
        })
            .then(response => {
                console.log(response);
                if (response.data.success) {
                    this.showSucces();
                } else {
                    this.showError(
                        "Oeps er ging iets mis! Probeer het later nog eens of stuur een e-mail naar info@partnersinintegriteit.nl.",
                    );
                }
            })
            .catch(error => {
                if (error.response.data) this.showError(error.response.data.error);
            });
    }

    private showSucces() {
        this.setState({ isSend: true, hasError: false });
    }

    private showError(error) {
        this.setState({ isSend: false, hasError: true, errorMessage: error });
    }

    public render() {
        return (
            <div className="Form">
                {this.state.hasError && <p>{this.state.errorMessage}</p>}
                {!this.state.isSend && (
                    <>
                        {this.props.form.fields.map(field => (
                            <FormRow key={field.name} id={field.name} label={field.label}>
                                <TextField
                                    id={field.name}
                                    onChange={(value: string) => this.setValue(value, field.name)}
                                    value=""
                                    required={field.required ? field.required : false}
                                    multiline={field.type === "textarea"}
                                />
                            </FormRow>
                        ))}
                        <ButtonRow>
                            <Button action={this.submit} disabled={this.state.hasErrors} inverted title="Verstuur">
                                Verstuur
                            </Button>
                        </ButtonRow>
                    </>
                )}
                {this.state.isSend &&
                    !this.state.hasError && (
                        <div className="Form__success">
                            <p>Bedankt voor uw bericht. We nemen zo spoedig mogelijk contact met u op.</p>
                        </div>
                    )}
            </div>
        );
    }
}

export default withForm(Form);
